<template>
  <div class="app__layout-default">
    <div class="app__layout-default__content-wrapper">
      <!-- Main content goes here -->
      <router-view class="flex a-center valign-center flex-column"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout'
};
</script>

<style lang="scss">
.app__layout-default {
  display: flex;
  flex-direction: column;
  background-color: $c-extra-light-gray;
  min-height: 100vh;

  justify-content: center;

  @media screen and (min-width: $screen-sm) {
    background-image: url('./../assets/img/bg-weltbewegend.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
  }

  &__head {
    svg,
    path {
      fill: $c-brand-second;
    }
  }

  &__content-wrapper {
    width: 100%;
  }
}
</style>
